import { formatDate } from "@gladis/ui/i18n";

/**
 * `2026-08-08` → `8 Aug 2026`, WITHOUT EVER CONSTRUCTING A `Date` FROM IT.
 *
 * `new Date("2026-08-08")` parses as UTC midnight and then renders in the browser's timezone, so anybody west
 * of Greenwich sees the 7th — for a value that has no time in it at all and cannot meaningfully be "converted"
 * to anywhere. The server takes care not to let that happen; undoing it in the browser would be worse, because
 * a browser's timezone is far less predictable than a server's.
 *
 * Shared by the snapshot history and the stat row rather than copied, because a second implementation is how
 * one screen comes to say "31 Jul 2026" and another "30 Jul 2026" about the same day.
 *
 * ==========================================================================================
 * THE MONTH NAMES WERE HAND-ROLLED, AND THAT IS WHY THIS SURVIVED THE FIRST SWEEP — 021
 * ==========================================================================================
 *
 * A `["Jan", "Feb", …]` array is a date formatter that calls no date API, so `one-date-formatter.ts`
 * could not see it and neither could a sweep of `.tsx` files. It rendered English months on a Dutch
 * page for as long as the rest of savings had been translated.
 *
 * `formatDate` keeps the property this file's header is about: it parses the `YYYY-MM-DD` as UTC and
 * formats in UTC, so a day never shifts for a reader west of Greenwich.
 */
export function formatDay(isoDay: string): string {
  return formatDate(isoDay, "short");
}
